var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileFavouriteSolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.836 1.58098C9.03979 0.629474 7.75004 2.03209 7.75004 2.03209C7.75004 2.03209 6.46022 0.629474 4.66395 1.58097C2.48832 2.73343 2.33209 7.24648 7.75004 9.25C13.1679 7.24648 13.0116 2.73343 10.836 1.58098Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26887 7.66178L3.25 19.8138C3.24749 21.4347 4.55429 22.75 6.16717 22.75H12.9695C13.2271 22.75 13.4741 22.6473 13.6564 22.4645L20.4645 15.6367C20.6473 15.4534 20.75 15.2045 20.75 14.945V4.18162C20.75 2.56253 19.4439 1.25 17.8328 1.25H12.4187C13.3779 2.30172 13.7195 3.87693 13.356 5.3886C12.8703 7.40826 11.1863 9.31202 8.1836 10.4224C7.90383 10.5258 7.59628 10.5258 7.3165 10.4224C5.48666 9.74572 4.14652 8.77441 3.26887 7.66178ZM12.5673 20.7941L18.8043 14.5391H14.0673C13.2389 14.5391 12.5673 15.2106 12.5673 16.0391V20.7941Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFavouriteSolidStandard);
export default __webpack_public_path__ + "static/media/file-favourite-solid-standard.84a08733664017e0368984a571ef6884.svg";
export { ForwardRef as ReactComponent };